import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
	HomeIcon,
	BuildingStorefrontIcon,
	ClipboardDocumentListIcon,
	TicketIcon,
	UserIcon,
	GiftIcon,
} from '@heroicons/react/24/outline';
import {
	HomeIcon as HomeIconSolid,
	BuildingStorefrontIcon as BuildingStorefrontIconSolid,
	ClipboardDocumentListIcon as ClipboardDocumentListIconSolid,
	TicketIcon as TicketIconSolid,
	UserIcon as UserIconSolid,
	GiftIcon as GiftIconSolid,
} from '@heroicons/react/24/solid';

interface NavItem {
	path: string;
	labelKey: string;
	icon: React.ComponentType<any>;
	activeIcon: React.ComponentType<any>;
	badge?: number;
}

const BottomNav: React.FC = () => {
	const { t } = useTranslation();

	const navItems: NavItem[] = [
		{
			path: '/',
			labelKey: 'common.home',
			icon: HomeIcon,
			activeIcon: HomeIconSolid,
		},
		{
			path: '/lottery',
			labelKey: 'common.lottery',
			icon: GiftIcon,
			activeIcon: GiftIconSolid,
		},
		{
			path: '/products',
			labelKey: 'common.products',
			icon: BuildingStorefrontIcon,
			activeIcon: BuildingStorefrontIconSolid,
		},
		{
			path: '/my-numbers',
			labelKey: 'common.orders',
			icon: ClipboardDocumentListIcon,
			activeIcon: ClipboardDocumentListIconSolid,
		},
		{
			path: '/profile',
			labelKey: 'common.profile',
			icon: UserIcon,
			activeIcon: UserIconSolid,
		},
	];

	return (
		<nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200">
			<div className="flex justify-around py-2">
				{navItems.map((item) => (
					<NavLink
						key={item.path}
						to={item.path}
						className={({ isActive }) =>
							`flex flex-col items-center py-2 px-3 relative transition-colors ${
								isActive ? 'text-indigo-600' : 'text-gray-500'
							}`
						}
					>
						{({ isActive }) => (
							<>
								{isActive ? (
									<item.activeIcon className="w-6 h-6" />
								) : (
									<item.icon className="w-6 h-6" />
								)}
								<span className="text-xs mt-1">{t(item.labelKey)}</span>
								{item.badge && (
									<span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
										{item.badge}
									</span>
								)}
							</>
						)}
					</NavLink>
				))}
			</div>
		</nav>
	);
};

export default BottomNav;
